/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from "react";
import { toast } from "react-toastify";

import { useDispatch } from "react-redux";

import { useLocation, useNavigate, useParams } from "react-router-dom";

import { DOCUMENT_ADD, DOCUMENT_DELETE, DOCUMENT_LIST, DOCUMENT_UPDATE } from "../../../repository/document_repo";
import { uploadFile } from "../../../repository/attendanceRepo";
import { personalDoc } from "../../../repository/auth";
import useReduxStore from "../../../hooks/useReduxStore";

const useDocumentProfile = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { selector: user } = useReduxStore("auth");
  const [spinner, setSpinner] = useState(false);
  const [controller, setController] = useState({ page: 1, rowsPerPage: 10 });
  const [totalCount, setTotalCount] = useState(0);
  const [documentList, setDocumentList] = useState([]);
  const [formError, setFormError] = useState({});
  const { id } = useParams(); // Get ID from URL params
  const location = useLocation(); // Get data from navigation state
  const isEditMode = Boolean(id);

  const userId = user?.userInfo?._id;

  const [openModal, setOpenModal] = useState({
    addDocument: false,
    editDocument: false,
    delete: false,
    data: null,
  });

  const [formData, setFormData] = useState({
    name: "",
    documents: [],
  });

const handleOpenModal = (type, data = null) => {
  setOpenModal({
    addDocument: type === "add",
    editDocument: type === "edit",
    delete: type === "delete",
    data: data || null,
  });

  if (type === "edit" && data) {
    setFormData({
      name: data.name || "",
      documents: data.documents || [],
      _id: data._id || "",
    });
  }

  if (type === "add") {
    setFormData({
      name: "",
      documents: [],
    });
  }
};
  const handleCloseModal = () => {
    setOpenModal({
      addDocument: false,
      editDocument: false,
      delete: false,
      data: null,
    });

    setFormData({});
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handlePagination = (obj) => {
    setController(obj);
  };

  // Initial load - for list page
  useEffect(() => {
    if (!isEditMode) {
      documentListAPI();
    }
  }, []);

  // Trigger API call when pagination changes - for list page
  useEffect(() => {
    if (!isEditMode) {
      documentListAPI();
    }
  }, [controller.page, controller.rowsPerPage]);

  const handleRemoveFile = (fileIndex) => {
    setFormData((prev) => ({
      ...prev,
      documents: prev.documents.filter((_, i) => i !== fileIndex),
    }));
  };

  const handleFileChange = async (event) => {
    const files = event.target.files;
    const fd = new FormData();

    if (files?.length > 5) {
      return toast.warn("You can only select up to 5 files.");
    }

    for (let i = 0; i < files.length; i++) {
      const f = files[i];

      if (f.size > 100 * 1024 * 1024) {
        return toast.warn(
          `File "${f.name}" exceeds the maximum size of 100 MB.`
        );
      }

      fd.append("files", f);
    }

    fd.append("type", "PERSONALDOC");

    try {
      setSpinner(true);
      let response = await uploadFile(fd);
      toast.success(response.message);

      const newFiles = response.data.map((item) => item.db_name);

      setFormData((prev) => ({
        ...prev,
        documents: [...prev.documents, ...newFiles],
      }));
    } catch (error) {
      toast.error(error.message);
    }

    setSpinner(false);
  };

  const documentListAPI = async () => {
    try {
      let payload = {
        count: controller.rowsPerPage,
        page: controller.page,
        userId: userId,
        isActive: true,
      };

      setSpinner(true);
      let response = await DOCUMENT_LIST(payload);
      setDocumentList(response?.data);
      setTotalCount(response?.totalCount || 0);
    } catch (error) {
      setDocumentList([]);
    }
    setSpinner(false);
  };

  const AddDocument = async () => {
    try {
      let payload = {
        name: formData.name,
        documents: formData.documents,
      };

      setSpinner(true);
      let response = await DOCUMENT_ADD(payload);
      if (response.code === 200) {
        toast.success(response.message || "Document added successfully");
        handleCloseModal();
        documentListAPI();
        setFormData({});
      } else {
        toast.error(response.message || "Document add failed");
      }
    } catch (error) {
      setDocumentList([]);
      toast.error(error?.message || "Something went wrong");
    }
    setSpinner(false);
  };

    const updateDocument = async () => {
  
      try {
        let payload = {
          name: formData.name,
          documents: formData.documents,
           _id: formData._id,
        };
  
        setSpinner(true);
        let response = await DOCUMENT_UPDATE(payload);
        if (response.code === 200) {
          toast.success(response.message || "Document updated successfully");
          documentListAPI();
           handleCloseModal();
          setFormData({});
        } else {
          toast.error(response.message || "Document update failed");
        }
      } catch (error) {
        documentListAPI([]);
      }
      setSpinner(false);
    };

 const updateDelete = async (id) => {
  
      try {
        let payload = {
       _id:id,
       isDeleted: true
        };
  
        setSpinner(true);
        let response = await DOCUMENT_DELETE(payload);
        if (response.code === 200) {
          toast.success(response.message || "Document deleted successfully");
                    const newPage =
    documentList.length === 1 && controller.page > 1
      ? controller.page - 1
      : controller.page;

  setController((prev) => ({ ...prev, page: newPage }));
          documentListAPI();
        } else {
          toast.error(response.message || "Document delete failed");
        }
      } catch (error) {
        documentListAPI([]);
      }
      setSpinner(false);
    };

  return {
    data: {
      spinner,
      formData,
      formError,
      isEditMode,
      controller,
      totalCount,
      documentList,
      openModal,
      personalDoc,
    },
    methods: {
      handleChange,
      handleOpenModal,
      handleCloseModal,
      handlePagination,
      AddDocument,
      handleRemoveFile,
      handleFileChange,
      updateDocument,
      updateDelete,
    },
  };
};

export default useDocumentProfile;
